const updates = [
  {
    time: '10分钟前',
    title: '「恋爱幻想曲」第128话更新',
    desc: '男主终于向女主告白，樱花树下的浪漫场景让读者们心动不已，评论区热议不断。',
    tag: '韩漫更新',
  },
  {
    time: '30分钟前',
    title: '「魔导纪元」第203话上线',
    desc: '远古魔法遗迹深处发现神秘力量，主角团遭遇前所未有的危机，战斗场面炸裂。',
    tag: '日漫更新',
  },
  {
    time: '1小时前',
    title: '「仙途无尽」第156话发布',
    desc: '渡劫期大能的真实身份曝光，整个修真界的格局即将被改写，国漫佳作不可错过。',
    tag: '国漫更新',
  },
  {
    time: '2小时前',
    title: '「暗夜追踪者」第89话更毕',
    desc: '真相浮出水面，连环案件的真凶竟然是他？悬疑反转让人拍案叫绝。',
    tag: '国漫更新',
  },
  {
    time: '3小时前',
    title: '「书灵奇缘」第67话来袭',
    desc: '新书灵登场，远古禁书的力量超乎想象，奇幻世界的冒险再度升级。',
    tag: '日漫更新',
  },
  {
    time: '4小时前',
    title: '「宫廷秘史」第112话放出',
    desc: '后宫权斗白热化，女主巧施妙计扭转乾坤，宫斗剧情精彩程度拉满。',
    tag: '韩漫更新',
  },
  {
    time: '6小时前',
    title: '「咖啡馆奇妙夜」番外篇发布',
    desc: '完结后的惊喜番外，老板娘的过去终于揭晓，治愈系粉丝们感动落泪。',
    tag: '特别更新',
  },
  {
    time: '8小时前',
    title: '新连载「星海浮沉」第1话开篇',
    desc: '科幻恋爱新作来袭！宇宙殖民时代下的浪漫故事，开篇即高能，不容错过。',
    tag: '新作上线',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">更新快讯</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">妖精漫画网实时更新动态，热门韩漫日漫国漫最新话一网打尽</p>
        </div>
        <div className="max-w-3xl mx-auto">
          {updates.map((u, i) => (
            <div key={i} className="relative pl-8 pb-6 last:pb-0">
              <div className="absolute left-0 top-1.5 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50 ring-2 ring-primary-200"></div>
              {i < updates.length - 1 && (
                <div className="absolute left-[5px] top-4 w-0.5 h-full bg-background-200"></div>
              )}
              <div className="bg-background-100 rounded-2xl p-5 border border-background-200/60 hover:border-primary-200 transition-colors">
                <div className="flex flex-wrap items-center gap-2 mb-2">
                  <span className="px-2.5 py-0.5 bg-secondary-100 text-secondary-700 text-[11px] font-medium rounded-full whitespace-nowrap">
                    {u.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{u.time}</span>
                </div>
                <h3 className="font-heading text-sm text-foreground-900 mb-1.5">{u.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{u.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}